import classNames from 'classnames';
import { FC } from 'react';
import styles from './Card.module.css';
import { CardProps } from './Card.types';

const Card: FC<CardProps> = ({ children, emphasis, className }) => (
  <div
    data-testid="Card"
    className={classNames(styles.card, {
      [styles.emphasis]: emphasis !== undefined,
      [styles[emphasis!]]: emphasis !== undefined,
      [className!]: className !== undefined,
    })}
  >
    {children}
  </div>
);

export default Card;
